import { createStandaloneToast } from '@chakra-ui/toast';
import React from "react"

export const { ToastContainer, toast } = createStandaloneToast();